import { app } from '../app';
import { resolve } from '../init/store';
import { HardToken } from '../models/hard-token';

app.factory('HardTokenService', HardTokenService);

/** @ngInject */
function HardTokenService($http) {

    return {
        get,
        getDetail,
        list,
        save,
        disable,
        enable,
        remove,
        u2fRegistrationStart,
        u2fRegistrationFinish,
        u2fResetRegistrationStart,
        u2fAuthenticationStart,
        u2fAuthenticationFinish,
        generateSyncUrl,
        getRegEmailData,
        putRegEmailData,
        resendRegEmail,
        sync,
        add,
    };

    function get(id) {
        return $http.get(
            `app/rest/admin/company/${companyId()}/hardtoken/${id}`
        ).then(response => new HardToken(response.data));
    }
    
    function getDetail(id) {
        return $http.get(
            `app/rest/admin/company/${companyId()}/ht/${id}`
        ).then(response => response.data);
    }

    function list() {
        return $http.get(
            `app/rest/admin/company/${companyId()}/hardtoken`
        ).then(response => response.data.map(
            tokenDto => new HardToken(tokenDto)
        ));
    }

    function save(token) {
        if (token.hasOwnProperty("isSelected")) {
            delete token.isSelected;
        }
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}`,
            token.toDto()
        ).then(response => response.data);
    }
    function remove(token) {
        return $http.delete(
                `app/rest/admin/company/${companyId()}/hardtoken/${token.id}`
            );
    }

    function disable(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/disable`
        ).then(response => response.data);
    }

    function enable(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/enable`
        ).then(response => response.data);
    }

    function u2fRegistrationStart(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/u2fregistrationstart`
        ).then(response => response.data);
    }
    function u2fResetRegistrationStart(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/u2fregistrationreset`
        ).then(response => response.data);
    }

    function u2fRegistrationFinish(token, data) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/u2fregistrationfinish`, data
        ).then(response => new HardToken(response.data));
    }

    function u2fAuthenticationStart(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/u2fauthenticationstart`
        ).then(response => response.data);
    }

    function u2fAuthenticationFinish(token, data) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/u2fauthenticationfinish`, data
        ).then(response => response.data);
    }

    function generateSyncUrl(token) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/synchronize/generate`
        ).then(response => response.data);
    }

	function getRegEmailData(token){
		 return $http.get(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/registrationEmail`
        ).then(response => response.data);
	}
	
	function putRegEmailData(token,email){
		 return $http.put(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/registrationEmail`,email
        ).then(response => response.data);
	}
	function resendRegEmail(token){
		 return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/registrationEmail/resend`
        ).then(response => response.data);
	}
	
    function sync(token, otps) {
        return $http.post(
            `app/rest/admin/company/${companyId()}/hardtoken/${token.id}/synchronize`, otps
        ).then(response => response.data);
    }

    function add(tokens) {
        return $http
            .post(`app/rest/admin/company/${companyId()}/hardtoken`, tokens)
            .then(response => response.data);
    }

    function companyId() {
        return resolve.companyId;
    }
}



// WEBPACK FOOTER //
// ./src/portal/services/hard-token-management.service.js